
import React from 'react';
import ReactDOM from 'react-dom';

// import registerServiceWorker from './registerServiceWorker';
import configureStore from './store/configureStore';
import { Provider } from 'react-redux';
import {BrowserRouter as Router, Route} from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './polyfills';

import './style/global.css';
import './index.css';
// import routes from './routes';
import App from './App';

const store = configureStore();
//exporting store to make it available outside react scope
export const appStore = store;

ReactDOM.render((
  <Provider store={store}>
    <Router>
      <Route path="/" component={App} />
    </Router>
  </Provider>
 ), document.getElementById('root'));
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js